import { connect } from 'react-redux'

import LinkNav from './LinkNav'

function mapStateToProps(state) {
  return {
    location: state.location,
  }
}

export default connect(mapStateToProps)(LinkNav)
